import React, { useEffect } from "react";
import { Card, Row, Col, Button, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../branchBalanceSlice";
import { SearchOutlined } from "@ant-design/icons";
import { fetchBranchBalance } from "../branchBalanceThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { fetchBranchList } from "../../../../store/commonThunks/lookups";

const BranchBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.branchBalance);
  const lookups = useSelector((state) => state.lookups);

  useEffect(() => {
      dispatch(fetchBranchList());
    
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleSubmit = () => {
    dispatch(fetchBranchBalance({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch report ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        {/* Branch Filter */}
        <Col xs={24} sm={12} md={6} lg={4}>
          <label>Branch</label>
          <SearchListAutoComplete
            optionsList={(lookups.branches || []).map((b) => ({
              sale_id: b.id,
              display_text: b.name,
            }))}
          
            onSelect={(obj) => handleFilterChange("branchId", obj?.sale_id)}
            placeholder="Select Branch"
            showAddNew={false}
          />
        </Col>

        {/* Submit */}
        <Col
          xs={24}
          sm={12}
          md={6}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Get Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default BranchBalanceFilters;
